<template>
  <div>
    <a-table
      :columns="columns"
      :data-source="fileList"
      :pagination="false"
      :scroll="{ x: 950 }"
      rowKey="id"
    >
      <span slot="index" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a style="color: #1890ff" @click="showDetailDrawer(record)">查看详情</a>
      </span>
    </a-table>

    <a-row :gutter="24">
      <a-col :span="12" style="margin: 10px">
        <a-button type="primary" @click="openMapMoudle"
          >手动进行地图标点</a-button
        >
        <a-button style="margin-left: 20px" @click="resetPoint"
          >重置标点</a-button
        >
      </a-col>
    </a-row>
    <TdtMapPoint
      :tk="tk"
      :center="[asset.lng, asset.lat]"
      :zoom="15"
      :markers="generateMarker(asset)"
    />
    <a-modal
      :visible="mapVisible"
      :footer="null"
      :width="1200"
      @cancel="closeMapMoudle"
      centered
      :destroyOnClose="true"
    >
      <div class="map-modal">
        <div class="map-left">
          <TdtSpotMap
            :tk="tk"
            :center="[asset.lng, asset.lat]"
            :zoom="15"
            :pickIcon="require('@/assets/locationMap3.png')"
            @picked="onPicked"
          />
        </div>
        <div class="map-right">
          <div class="map-title">标记信息(请点击地图拾取位置)</div>
          <div class="map-card">
            <div>
              <span class="map-card-label">详细地址：</span>
              <span>{{ mapPointInfo.address || "-" }}</span>
            </div>
            <div>
              <span class="map-card-label">省份/直辖市：</span>
              <span>{{ mapPointInfo.province || "-" }}</span>
            </div>
            <div>
              <span class="map-card-label">城市：</span>
              <span>{{ mapPointInfo.city || "-" }}</span>
            </div>
            <div>
              <span class="map-card-label">街镇：</span>
              <span>{{ mapPointInfo.town || "-" }}</span>
            </div>
            <div>
              <span class="map-card-label">道路：</span>
              <span>{{ mapPointInfo.street || "-" }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部按钮（更紧凑） -->
      <div class="map-footer">
        <a-button type="primary" @click="savePoint"> 标点完成 </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    width: 60,
    scopedSlots: { customRender: "index" },
  },
  {
    title: "房源名称",
    width: 260,
    dataIndex: "housingResName",
  },
  {
    title: "房源编号",
    width: 150,
    dataIndex: "housingResNumber",
  },

  {
    title: "详细地址",
    width: 280,
    dataIndex: "housingResAddress",
  },
  {
    title: "租赁用途",
    width: 150,
    dataIndex: "leaseUseType",
  },
  {
    title: "租赁面积(平方米)",
    width: 140,
    dataIndex: "leaseArea",
  },
  {
    title: "操作",
    fixed: "right",
    width: 140,
    scopedSlots: { customRender: "action" },
  },
];
import TdtMap from "@/components/TdtMap";
import TdtSpotMap from "@/components/TdtSpotMap";
import TdtMapPoint from "@/components/TdtMapPoint";
export default {
  components: {
    TdtMap,
    TdtSpotMap,
    TdtMapPoint,
  },
  props: {
    form: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      tk: "a3789da931616fce36077d6fd5712667",
      columns,
      fileList: [
        {
          assetId: 0,
          housingResName: "上海市金山区蒙山路101号",
          housingResNumber: "FY202523447",
          housingResAddress: "上海市金山区蒙山路101号",
          leaseUseType: "商业;楼宇办公",
          leaseArea: "2824.34",
        },
      ],
      //form里的值
      asset: {
        lng: 121.35,
        lat: 30.75,
      },
      defaultLocation: {
        lng: 121.35,
        lat: 30.75,
      },
      //form里的值
      mapVisible: false,
      // 地图标点信息
      mapPointInfo: {
        address: "",
        province: "",
        city: "",
        district: "",
        lng: "",
        lat: "",
      },
    };
  },
  methods: {
    showDetailDrawer(record) {
      console.log(record);
    },
    openMapMoudle() {
      (this.mapPointInfo = {
        address: "",
        province: "",
        city: "",
        district: "",
        lng: this.asset.lng,
        lat: this.asset.lat,
      }),
        (this.mapVisible = true);
    },
    closeMapMoudle() {
      this.mapVisible = false;
    },
    savePoint() {
      if (
        !(
          !this.mapPointInfo ||
          !this.mapPointInfo.lng ||
          !this.mapPointInfo.lat
        )
      ) {
        this.asset.lng = this.mapPointInfo.lng;
        this.asset.lat = this.mapPointInfo.lat;
      }
      this.mapVisible = false;
    },
    generateMarker(asset) {
      if (!asset || !asset.lng || !asset.lat) return [];
      return [
        {
          lng: asset.lng,
          lat: asset.lat,
          icon: require("@/assets/locationMap3.png"),
        },
      ];
    },
    // 地图上选择地点
    onPicked(data) {
      const municipality = [
        "北京市",
        "上海市",
        "天津市",
        "重庆市",
        "台湾省",
        "香港特别行政区",
        "澳门特别行政区",
      ];

      // 如果是直辖市，province 直接等于 city
      if (municipality.includes(data.province)) {
        data.city = data.province;
      }
      this.form.longitude = data.lng;
      this.form.latitude = data.lat;
      // 更新右侧显示用的 info
      this.mapPointInfo = {
        address: data.address,
        province: data.province,
        city: data.city,
        district: data.district,
        town: data.town,
        street: data.street,
        lng: data.lng,
        lat: data.lat,
      };
    },
    resetPoint() {
      this.asset.lng = this.defaultLocation.lng;
      this.asset.lat = this.defaultLocation.lat;
    },
  },
};
</script>

<style>
.map-modal {
  display: flex;
  width: 100%;
  border-radius: 6px;
  margin-bottom: 6px;
}
.map-left {
  flex: 9;
  min-width: 0;
  position: relative;
}
.map-right {
  flex: 3;
  border-left: 1px solid #e6e6e6;
  padding: 4px;
  background: #fafafa;
  display: flex;
  flex-direction: column;
}
.map-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 14px;
}
.map-card {
  background: #fff;
  padding: 18px 16px;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 14px;
  font-size: 14px;
  color: #444;
}
.map-card-label {
  font-weight: 500;
  color: #666;
}
.map-footer {
  margin-top: 10px;
  width: 100%;
  text-align: center;
}
</style>